import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Card } from 'react-bootstrap';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useSite } from '../context/SiteContext';
import api from '../services/api';

const Contact = () => {
  const { config } = useSite();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      await api.post('/submit-contact/', formData);
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      setError('Failed to send message. Please try again.');
      console.error('Error submitting contact:', error);
    }
  };

  return (
    <Container className="py-5">
      <h1 className="page-title mb-5">Contact Us</h1>
      
      <Row>
        <Col lg={4} className="mb-4">
          <Card className="h-100">
            <Card.Body>
              <h5 className="mb-4">Get in Touch</h5>
              
              {config?.address && (
                <div className="mb-3">
                  <h6><FaMapMarkerAlt className="text-primary me-2" />Address</h6>
                  <p>{config.address}</p>
                </div>
              )}
              
              {config?.contact_phone && (
                <div className="mb-3">
                  <h6><FaPhone className="text-primary me-2" />Phone</h6>
                  <p>{config.contact_phone}</p>
                </div>
              )}
              
              {config?.contact_email && (
                <div className="mb-3">
                  <h6><FaEnvelope className="text-primary me-2" />Email</h6>
                  <p>{config.contact_email}</p>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={8}>
          {submitted && (
            <Alert variant="success">
              <Alert.Heading>Message Sent Successfully!</Alert.Heading>
              <p>Thank you for contacting us. We will respond to your message soon.</p>
            </Alert>
          )}

          {error && <Alert variant="danger">{error}</Alert>}

          <Card>
            <Card.Body>
              <h5 className="mb-4">Send us a Message</h5>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Name *</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>Subject *</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Message *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" size="lg">
                  Send Message
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
